import { createAction, props } from '@ngrx/store';

import { SavedLocation } from './location.state';

export const setLocation = createAction(
  '[Location] Set Location',
  props<{ location: SavedLocation }>()
);

export const clearLocation = createAction('[Location] Clear Location');

export const loadLocationFromStorage = createAction('[Location] Load From Storage');

export const setRegionId = createAction(
  '[Location] Set Region Id',
  props<{ regionId: string }>()
);
